module.exports = __webpack_public_path__ + "static/media/slide3.f90fbd7b.jpg";